import { active } from '../../../styles/layout/components/Layout/Navbar/activeItem.module.scss';

export const ACTIVE_ITEM_CLASS_NAME = `${active} active`;